import React, { useState, useEffect, useCallback } from 'react';
import { Box, Flex, Text, Heading, IconButton, Button } from '@chakra-ui/react';
import ChatBox from './ChatBox';
import { useAuth } from '../contexts/AuthContext';
import { useParams } from 'react-router-dom';
import { ChatIcon, CloseIcon } from '@chakra-ui/icons';

const AnythingChat = () => {
  const { currentUser } = useAuth();
  if (!currentUser) return null;
  const { targetUserId } = useParams();
  const [isChatOpen, setIsChatOpen] = useState(true);
  
  const handleToggle = () => {
    setIsChatOpen(!isChatOpen);
  };
  return (
    <Box w="100vw" minH="100vh" position="relative">
        {/* メインコンテンツ部分 - 画面幅いっぱいに表示 */}
        <Box p={4} w="100%">
          <Heading size="md">ご相談</Heading>
          <Box 
            bg="gray.100"
            p={4}
            borderRadius="md"
            w="100%"
          >
            <Text>
                なんでもご気軽にご相談ください！
            </Text>
            <Text>
                ただし、間取りや設備の選択に関するご相談はそれぞれのページからのメッセージにてお願いします。
            </Text>
          </Box>
        </Box>

        {/* デスクトップ用縦書きチャットボタン */}
        <Box
            position="fixed"
            right="0"
            top="50%"
            transform="translateY(-50%)"
            zIndex={20}
            display={{ base: "none", md: isChatOpen ? "none" : "block" }}
        >
            <Button
                onClick={handleToggle}
                bg="rgba(0, 0, 0, 0.7)"
                color="white"
                _hover={{ bg: "rgba(0, 0, 0, 0.8)" }}
                _active={{ bg: "rgba(0, 0, 0, 0.9)" }}
                borderRadius="md"
                px={3}
                py={8}
                fontSize="sm"
                fontWeight="medium"
                boxShadow="lg"
                backdropFilter="blur(10px)"
                minH="120px"
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={2}
                sx={{
                    writingMode: 'vertical-rl',
                    textOrientation: 'mixed',
                    '& > *': {
                        writingMode: 'vertical-rl',
                        textOrientation: 'mixed'
                    }
                }}
            >
                <ChatIcon boxSize="16px" />
                <Text
                    fontSize="sm"
                    fontWeight="medium"
                    sx={{
                        writingMode: 'vertical-rl',
                        textOrientation: 'mixed'
                    }}
                >
                    チャットで相談
                </Text>
            </Button>
        </Box>
        
        {/* モバイル用チャットバナー */}
        <Box
            position="fixed"
            bottom="20px"
            left="50%"
            transform="translateX(-50%)"
            zIndex={30}
            display={{ base: isChatOpen ? "none" : "block", md: "none" }}
        >
            <Button
                onClick={handleToggle}
                leftIcon={<ChatIcon />}
                bg="rgba(0, 0, 0, 0.7)"
                color="white"
                _hover={{ bg: "rgba(0, 0, 0, 0.8)" }}
                _active={{ bg: "rgba(0, 0, 0, 0.9)" }}
                borderRadius="full"
                px={6}
                py={3}
                fontSize="sm"
                fontWeight="medium"
                boxShadow="lg"
                backdropFilter="blur(10px)"
            >
                チャットで相談
            </Button>
        </Box>

        {/* チャット部分 - オーバーレイ表示 */}
        <Box 
            w={isChatOpen ? {base: "100%", sm: "400px"} : "0"}
            maxW="100%"
            h="calc(100vh - 140px)"
            position="fixed"
            top="140px"
            right="0"
            transition="width 0.3s ease-in-out"
            overflowY="auto"
            zIndex={1000}
            bg="white"
            borderWidth="1px"
            borderLeftWidth="1px"
            borderColor="gray.200"
            boxShadow="lg"
        >
            {/* チャットを閉じるボタン */}
            <IconButton
                icon={<CloseIcon />}
                onClick={() => setIsChatOpen(false)}
                aria-label="チャットを閉じる"
                size="sm"
                variant="ghost"
                color="gray.500"
                _hover={{ bg: "gray.100" }}
                position="absolute"
                top="10px"
                right="10px"
                zIndex={20}
                bg="white"
                borderRadius="full"
                boxShadow="sm"
            />
            <ChatBox itemType="anything" targetUserId={targetUserId} isOpen={isChatOpen} />
        </Box>
    </Box>
  );
};

export default AnythingChat; 